
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';


import { environment } from '@env/environment';
import { MasterMasterGroupsUsersService } from './master-master-groups-users.service';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';
const BASE_PATH = environment.basePath;
/**
* This Component manages the presentation logic of Edit screen
*
*/
@Component({
  selector: 'app-master-master-groups-users',
  templateUrl: './master-master-groups-users.component.html',
  styleUrls: ['./master-master-groups-users.scss']
})
export class MasterMasterGroupsUsersComponent implements OnInit {

  users: any;
  displayedColumns: string[] = ["name", "login", "permissionGroup", "status"];
  sorted: boolean = false;
  filterAutoComplete: Array<any>;
  usersComplete: any;
  @Input()
  name: string;
  @Input()
  id: string;

  @ViewChild('sortUsers', { static: false }) sortUsers: MatSort;

  usersFilter: any;
  constructor(
    private shared : SharedVariable,
    private _masterUsersService: MasterMasterGroupsUsersService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.getUsers();
  }

  async getUsers() {
    const payload = {id:this.id};
    
    let result = this.shared.resultUsers
    result['users'] = result['users'].filter(el => {
      return el.checked == true
    });
    result['users'].map((u) => u.code);
    
    this.users = new MatTableDataSource<any>(result['users'].naturalSort(['name']));

    this.users.sortingDataAccessor = (data, sortHeaderId) => {
      return data[sortHeaderId].naturalNormalize();
    }
    this.users.sort = this.sortUsers;
  }

  filterUsers(event: Event) {
    this.users.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = ''
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    }
    this.usersFilter = (event.target as HTMLInputElement).value;
    this.users.filter = this.usersFilter;

    if (this.usersFilter.length > 0 && this.usersFilter.length % 2 == 0) {
      this.usersComplete = this.users.filteredData;
    } else if (this.usersFilter.length == 0) {
      this.usersComplete = []
    }
  }
}
